<div class="mb-3" [class.invalid-feedback]="showError">
  <label *ngIf="props.label && props.hideLabel !== true" [attr.for]="id">
    {{ props.label }}
    <span *ngIf="props.required && props.hideRequiredMarker !== true">*</span>
  </label>

  <tui-editor
    [formControl]="formControl"
    [formlyAttributes]="field"
    [style.max-height.px]="maxHtmlContentLength"
  />
  <small *ngIf="props.description" class="form-text text-muted">{{ props.description }}</small>
</div>
